import React, { useEffect, useState } from 'react';
var Link = function (props) {
    var to = props.to, target = props.target, className = props.className, activeClassName = props.activeClassName, style = props.style, children = props.children, onClick = props.onClick;
    var _a = useState(false), isActive = _a[0], setIsActive = _a[1];
    var onLocationChange = function () { return setIsActive(checkActive()); };
    useEffect(function () {
        if (!!activeClassName) {
            onLocationChange();
            window.addEventListener('popstate', onLocationChange);
        }
        return function () { return window.removeEventListener('popstate', onLocationChange); };
    }, []);
    var handleClick = function (nativeEvent) {
        var _a, _b;
        if (target !== '_blank') {
            nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.preventDefault();
            (_b = (_a = window.history) === null || _a === void 0 ? void 0 : _a.pushState) === null || _b === void 0 ? void 0 : _b.call(_a, {}, '', to);
            var navEvent = new PopStateEvent('popstate');
            window.dispatchEvent(navEvent);
        }
        if (!!onClick)
            onClick(nativeEvent);
    };
    var checkActive = function () {
        var locationPathname = location.pathname.toLowerCase();
        var toPathname = to.toLowerCase();
        return (locationPathname === toPathname ||
            (locationPathname.startsWith(toPathname) &&
                locationPathname.charAt(toPathname.length) === '/'));
    };
    var classes = [];
    if (className)
        classes.push(className);
    if (isActive && activeClassName)
        classes.push(activeClassName);
    var rel = target === '_blank' ? 'noopener noreferrer' : undefined;
    return (React.createElement("a", { className: classes.join(' '), style: style, href: to, onClick: handleClick, target: target, rel: rel }, children));
};
export default Link;
